import ImageUpload from "../../../layout/ImageUpload";
import {useSetting} from "../../../contexts/setting";
import {productIconUrl} from "libs/productIcon";

/**
 * Parts of the Demo Video banners (pages/Releases/DemoVideo). The Figma
 * handoff (file "YouTube", node 12710:1400) names them: brand/<product>/icon,
 * content/screenshot.
 */

/** The texts of a field: per banner id, and "main" for the banners that follow the page. */
export type DemoVideoTexts<Field extends string> = Record<Field, Record<string, string | undefined>>;

/** The compact colour mark of the product, 120x120. Never recoloured. */
export const DemoVideoIcon = () => {
  const {product} = useSetting();
  return (
    <img className="dv-icon" src={productIconUrl(product.value)} alt={product.label} />
  );
};

/**
 * The screenshot the user uploads (content/screenshot). The design owns the
 * zone, so it shows whatever the Dropzone toggle of other pages says.
 */
export const DemoVideoScreenshot = ({id}: {id: string}) => (
  <div className="dv-screenshot">
    <ImageUpload id={id} className="dv-screenshot-upload" alwaysVisible />
  </div>
);
